const IMG = "https://static.prod-images.emergentagent.com/jobs/d188e8a6-e5bc-4918-9b96-c47927d33980/images";

export const PACK_IMAGE = `${IMG}/f3ee218c79bcbff50a1133bbcbf7636addee510190f1783a72c84a616b659968.jpeg`;
export const HERO_IMAGE = `${IMG}/e9105161f6c87d44fa3e4ef57d2ca22f65849286f166e01983a35bf92c0ca53d.jpeg`;
export const FARM_IMAGE = `${IMG}/1e36e709dab2fd410b174e384602142efb440dad9a6aaa8273ea7c7a6673e855.jpeg`;

export const BOTANICALS = [
  {
    id: "rose",
    name: "Rose Petals",
    latin: "Rosa damascena",
    tagline: "Heart-opening & Aroma",
    benefit: "In Ayurveda, rose is tridoshic — cooling Pitta while opening the heart chakra, Anahata. It softens emotional tension and invites presence.",
    role: "Lends the blend its signature floral top-note. Each draw carries a velvet aroma that lingers like attar on the breath.",
    image: `${IMG}/9734a34d820808c2451d4f74b9afab08f0e9d1d5e73d1ff31f17c4948d34a72d.jpeg`,
  },
  {
    id: "tulsi",
    name: "Tulsi",
    latin: "Ocimum sanctum",
    tagline: "Stress-relief & Immunity",
    benefit: "Revered as 'The Incomparable One', tulsi is Ayurveda's supreme adaptogen — steadying the nervous system, fortifying ojas, and clearing the subtle channels.",
    role: "The sacred backbone of the blend. Warm, peppery and grounding — tulsi gives the smoke its meditative depth.",
    image: `${IMG}/db5f9ba7b681c43d2126e705060edf1b662f6cc52156b4a2d96f0cfced0e5cb2.jpeg`,
  },
  {
    id: "brahmi",
    name: "Brahmi",
    latin: "Bacopa monnieri",
    tagline: "Mental clarity",
    benefit: "Named for Brahman, universal consciousness. Brahmi is the classic medhya rasayana — a rejuvenator of intellect, memory and focus.",
    role: "Sharpens the ritual. A clean, green herbaceous note that keeps the mind lucid while the body settles.",
    image: `${IMG}/4cddc2d7fe485dc32b71feb68994c78097b23dc59077ffed89a8e7c39680cc72.jpeg`,
  },
  {
    id: "lavender",
    name: "Lavender",
    latin: "Lavandula angustifolia",
    tagline: "Deep relaxation",
    benefit: "A gentle nervine that pacifies Vata. Lavender quiets mental chatter and prepares body and breath for stillness.",
    role: "The exhale note. Its soft floral coolness rounds the smoke and signals the nervous system to release.",
    image: `${IMG}/ff7d8d5e49bab1991411df19170b7f2f462a68249a34e3a2a35211231512383f.jpeg`,
  },
  {
    id: "mullein",
    name: "Mullein",
    latin: "Verbascum thapsus",
    tagline: "Lung support & Smooth smoke",
    benefit: "The great respiratory ally. Mullein has been used for centuries to soothe and support the lungs and open the airways.",
    role: "The velvet base of every Sage & Spirit blend — an exceptionally light, smooth burn that carries the other botanicals.",
    image: `${IMG}/8ca5f3f86557e2cfed2565db913e41965dd43db6d03d6aabe269367caeb7b25c.jpeg`,
  },
  {
    id: "bluelotus",
    name: "Blue Lotus",
    latin: "Nymphaea caerulea",
    tagline: "Lucidity & Calm",
    benefit: "The flower of Egyptian and Vedic ritual. Blue lotus gently elevates mood and induces a serene, dream-adjacent lucidity.",
    role: "The transcendent note. A subtle euphoric smoothness that turns an ordinary pause into ceremony.",
    image: `${IMG}/5ad85a02ae16f1f454ba5a88aff1c0b301abbc976ef80a39097340e6193db38d.jpeg`,
  },
  {
    id: "chamomile",
    name: "Chamomile",
    latin: "Matricaria chamomilla",
    tagline: "Gentle sedation",
    benefit: "Sun-natured yet deeply calming, chamomile settles Pitta and eases the body toward rest without dulling awareness.",
    role: "A honeyed, apple-soft warmth in the middle of the draw — the note that makes the ritual feel like dusk.",
    image: `${IMG}/fa451729f272dfc060acfe2a05a333f19c6979cd37e6fe4c91ea2ad4e812d804.jpeg`,
  },
  {
    id: "mugwort",
    name: "Mugwort",
    latin: "Artemisia vulgaris",
    tagline: "Dream enhancement & Ritual",
    benefit: "The herb of the moon. Mugwort has anchored ceremonial smoking traditions across cultures, celebrated for vivid dreams and inner sight.",
    role: "The mystic thread. Dry, silvery and aromatic — it deepens the evening blend and honours the ancient lineage of ritual smoke.",
    image: `${IMG}/49c5318e5ace1dbd94450a54659cf1b3fc32526380d5d7833949d52168263141.jpeg`,
  },
  {
    id: "ashwagandha",
    name: "Ashwagandha",
    latin: "Withania somnifera",
    tagline: "Vitality & Balance",
    benefit: "The royal rasayana of Ayurveda. Ashwagandha restores strength, balances stress hormones and rebuilds deep vitality.",
    role: "The grounding earth-note. It anchors the blend, leaving the body steady and quietly energised after the final draw.",
    image: `${IMG}/c219d5fecf7cabd4c9b22923b4842dd7446a362af05701dfbb6fa85d91acf873.jpeg`,
  },
  {
    id: "peppermint",
    name: "Peppermint",
    latin: "Mentha piperita",
    tagline: "Cooling sensation & Refreshment",
    benefit: "Sheeta virya — cooling potency. Peppermint refreshes the senses, opens the breath and leaves clarity in its wake.",
    role: "The bright finish. A crystalline cool on the inhale that keeps every draw clean, crisp and effortless.",
    image: `${IMG}/7525a0f1ed4abc3723b9a38360d05568a52f76e59a76badb1fd10fe33888140b.jpeg`,
  },
];
